import { createUseCheckboxFilter } from '@/creditflowresearch/ui/common/hooks/sidebar/useCheckboxFilter';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import type { TFilterPayload } from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilter';

const useCheckboxFilter = createUseCheckboxFilter<TFilterPayload>(useCorporateBondScreenerSidebarFilterContext);

export default useCheckboxFilter;
